import PinUnlockModal from "../../components/pin-unlock-modal";
import AppHandlerProvider from "./app-handler-provider";
import DebugModalProvider from "./debug-modal-provider";
import DeleteEventProvider from "./delete-event-provider";
import InvoiceModalProvider from "./invoice-modal-provider";
import MuteModalProvider from "./mute-modal-provider";
import PostModalProvider from "./post-modal-provider";
import ReportModalProvider from "./report-modal-provider";

/** Providers that provide functionality to pages (needs to be rendered under a router) */
export function RouteProviders({ children }: { children: React.ReactNode }) {
  return (
    <DeleteEventProvider>
      <MuteModalProvider>
        <ReportModalProvider>
          <DebugModalProvider>
            <InvoiceModalProvider>
              <PostModalProvider>
                <AppHandlerProvider>
                  {children}
                  <PinUnlockModal />
                </AppHandlerProvider>
              </PostModalProvider>
            </InvoiceModalProvider>
          </DebugModalProvider>
        </ReportModalProvider>
      </MuteModalProvider>
    </DeleteEventProvider>
  );
}
